/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'drag-vertical-variant': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11 21H9V3h2v18m4-18h-2v18h2V3z"/>'
  }
})
